import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TabsModule } from 'primeng/tabs';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { ToolbarContactInfoComponent } from './components/toolbar-contact-info/toolbar-contact-info.component';
import { UserService } from '../../shared/services/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { User } from '../../shared/models/user.model';
import { StyleClassModule } from 'primeng/styleclass';
import { ToolbarUserMenuComponent } from './components/toolbar-user-menu/toolbar-user-menu.component';
import { Router, RouterModule } from '@angular/router';
import { DockItem, ToolbarTab } from './models/toolbar.model';
import { ToolbarDockComponent } from './components/toolbar-dock/toolbar-dock.component';
import { ToolbarReportBackendComponent } from './components/toolbar-report-backend/toolbar-report-backend.component';
import { CwComponentsModule } from '../../shared/components/components.module';

@Component({
  selector: 'zp-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: [
    './toolbar.component.scss'
  ],
  standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        TabsModule,
        AvatarModule,
        ButtonModule,
        PopoverModule,
        ToolbarContactInfoComponent,
        StyleClassModule,
        ToolbarUserMenuComponent,
        ToolbarDockComponent,
        ToolbarReportBackendComponent,
        CwComponentsModule
    ]
})
export class ToolbarComponent implements OnInit {

  protected readonly environment = environment;

  public tabs: ToolbarTab[] = [
    { name: 'Dashboard', route: '/dashboard' },
    { name: 'Feeds', route: '/feeds' },
    { name: 'Transactions', route: '/transactions' },
    { name: 'Reports', route: '/reports' }
  ];

  public dockItems: DockItem[] = [];

  public user: User;

  constructor(private userService: UserService, private router: Router, private activatedRoute: Router) {
    this.userService.user$
        .pipe(takeUntilDestroyed())
        .subscribe((user) => this.user = user);
  }

  ngOnInit() {
    this.dockItems = this.createMenuItems();
  }

  public createMenuItems(): DockItem[] {
    return this.tabs.map((tab) => ({
      label: tab.name,
      icon: `ic_${tab.name.toLowerCase()}`,
      command: () => {
        this.router.navigate([tab.route]);
      }
    }))
  }

  public get isAmAssigned(): boolean {
    return this.user && this.user.accountManagerAssigned;
  }

  public get userFirstLetter(): string {
    return this.user && this.user.publisherDetails.userInfo.firstName.charAt(0).toUpperCase();
  }

}
